import React from 'react'
import LibraryDetail from '../../components/LibraryDetail/LibraryDetail'

export const LibraryDetailPage = () => {
  return (
    <div><LibraryDetail/></div>
  )
}
